import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CalculateValidationTextFn, ControlSupportingTextComponent } from '../../internal/control-supporting-text/control-supporting-text.component';
import { AbstractControl, FormsModule } from '@angular/forms';
import { LayoutControlComponent } from '../../internal/layout-control/layout-control.component';
import { ControlLabelComponent } from '../../internal/control-label/control-label.component';

@Component({
  selector: 'app-standard-decorator',
  standalone: true,
  imports: [ControlLabelComponent, ControlSupportingTextComponent, LayoutControlComponent, FormsModule],
  templateUrl: './standard-decorator.component.html',
  styleUrl: './standard-decorator.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class StandardDecoratorComponent {
  readonly caption = input.required<string>();
  readonly control = input<AbstractControl<unknown, unknown> | null>(null);
  readonly infoText = input<string>('');
  readonly inputId = input<string | null>(null);
  readonly calculateValidationText = input<CalculateValidationTextFn | string>();

  get isValid(): boolean {
    const control = this.control();
    const isValid = !control || (control.invalid !== true || (control.pristine && control.untouched));
    return isValid;
  }
}
